export default __webpack_public_path__ + "static/media/airbnb2.1fd7a4df.jfif";